// src/redux/reducers/caReducer.js

import { SET_FACTURES_CA } from "../actions/caActions";


const initialState = {
    facturesCA: [], // Toutes les notifications
};

const caReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FACTURES_CA:
            return {
                ...state,
                facturesCA: action.payload
            };

        default:
            return state;
    }
};

export default caReducer;
